export const APP_METADATA = {
  companyName: 'Swagpro Medical Billing Dashboard',
  version: '0.1.0',
  lastUpdated: '2026-04-10',
} as const;